import { IFiles, IEvent } from '@interfaces/IEvent';
import { EEventsActions, EventsActions } from './events.actions';
import { IEventsState, initialEventsState } from './events.state';

export const eventsReducers = (
  state = initialEventsState,
  action: EventsActions
): IEventsState => {
  switch (action.type) {
    //visits
    case EEventsActions.ClearEventVisits:
      return {
        ...state,
        success: false,
        events: [],
        periodEvents: {},
        selectedEventVisits: [],
        errors: {},
      };
    case EEventsActions.GetEventVisits:
      return {
        ...state,
        loading: { ...state.loading, getVisits: true },
      };
    case EEventsActions.GetEventVisitsSuccess:
      return {
        ...state,
        selectedEventVisits: action.ids,
        loading: { ...state.loading, getVisits: false },
      };

    case EEventsActions.GetEventVisitsFailure:
      return { ...state, loading: { ...state.loading, getVisits: false } };
    case EEventsActions.AddEventVisits:
      return {
        ...state,
        loading: { ...state.loading, addVisits: true, success: false },
      };
    case EEventsActions.AddEventVisitsSuccess:
      return {
        ...state,
        loading: { ...state.loading, addVisits: false },
        success: true,
      };

    case EEventsActions.AddEventVisitsFailure:
      return { ...state, loading: { ...state.loading, addVisits: false } };

    case EEventsActions.AddEvent:
      return { ...state, loading: { ...state.loading, addEvent: true } };
    case EEventsActions.AddEventFailure:
      return {
        ...state,
        errors: { ...state.errors, addEvent: action.errors },
        loading: { ...state.loading, addEvent: false },
      };
    case EEventsActions.AddEventSuccess:
      return {
        ...state,
        errors: { ...state.errors, addEvent: {} },
        loading: { ...state.loading, addEvent: false },
      };

    //event files
    case EEventsActions.DeleteEventFile:
      return {
        ...state,
        loading: { ...state.loading, eventFile: true },
      };
    case EEventsActions.DeleteEventFileSuccess:
      return {
        ...state,
        selectedEvent: state.selectedEvent
          ? {
              ...state.selectedEvent,
              files: setFiles(state.selectedEvent, action.file_id),
            }
          : null,
        loading: { ...state.loading, eventFile: false },
      };
    case EEventsActions.DeleteEventFileFailure:
      return {
        ...state,
        loading: { ...state.loading, eventFile: false },
      };
    default:
      return { ...state };
  }
};

const setFiles = (selectedEvent: IEvent | null, fileId: number): IFiles[] => {
  let files: IFiles[] = [];

  if (selectedEvent && selectedEvent.files) {
    files = [...selectedEvent.files];
  }

  files.splice(
    files.findIndex(f => f.id === fileId),
    1
  );

  return files;
};
